import Head from "next/head";

import BecomeAnAffiliateMain from "@/components/become-an-affiliate/become-an-affiliate-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function BecomeAnAffiliate() {
  return (
    <>
      <Head>
        <title>{seoData.BECOME_AN_AFFILIATE.title}</title>
        <SeoMetaData data={seoData.BECOME_AN_AFFILIATE} />
      </Head>

      <BecomeAnAffiliateMain />
    </>
  );
}
